import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Icon = FontAwesomeIcon
export default Icon